import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_498_5)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M32 18C39.8 18 46 24.2 46 32C46 39.8 39.8 46 32 46C24.2 46 18 39.8 18 32C18 24.2 24.2 18 32 18ZM32 16C23.2 16 16 23.2 16 32C16 40.8 23.2 48 32 48C40.8 48 48 40.8 48 32C48 23.2 40.8 16 32 16Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M32 42.4C28 42.4 24.4 40 22.8 36.2L24.6 35.4C25.8 38.4 28.8 40.2 32 40.2C35.2 40.2 38.2 38.2 39.4 35.4L41.2001 36.2C39.6001 40.2 36 42.4 32 42.4ZM30 28C30 28.5304 29.7893 29.0391 29.4143 29.4142C29.0392 29.7893 28.5305 30 28 30C27.4696 30 26.9609 29.7893 26.5858 29.4142C26.2108 29.0391 26 28.5304 26 28C26 27.4696 26.2108 26.9609 26.5858 26.5858C26.9609 26.2107 27.4696 26 28 26C28.5305 26 29.0392 26.2107 29.4143 26.5858C29.7893 26.9609 30 27.4696 30 28ZM38 28C38 28.5304 37.7893 29.0391 37.4143 29.4142C37.0392 29.7893 36.5305 30 36 30C35.4696 30 34.9609 29.7893 34.5858 29.4142C34.2108 29.0391 34 28.5304 34 28C34 27.4696 34.2108 26.9609 34.5858 26.5858C34.9609 26.2107 35.4696 26 36 26C36.5305 26 37.0392 26.2107 37.4143 26.5858C37.7893 26.9609 38 27.4696 38 28Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_498_5",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "none",
			transform: "translate(16 16)"
		})
	}) })]
});
export default SvgProfile;
